



































































































































































































































































































































































































































































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeSuprimentosStore from '@/components/Backoffice/Store/BackofficeSuprimentosStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'

import { timeout, humanTime, displayColorBySituation, displayColorByStatus, verifyEtapaSuprimentos, timeoutDefault, groupCollectionByField, maskHour, lembreteColor, getHospitalAreaName, backofficeRoute } from '@/utils/common'
import { StatusSlaEnum, IRequestMessage, RequestMessage, Loading, LembreteEnum, AgendamentoCirurgia, SituacaoEnum, TipoDocumentoUpload, PendenciaMensagem, TipoMensagemEnum, AgendamentoSolicitacaoItem, Solicitacao, User, Procedimento } from '@/types/_'
import { Autorizacao, PendenciaSolicitacao, Suprimentos } from '@/types/core'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'

@Component({ filters: { humanTime } })

export default class ViewBackofficeSuprimentos extends Vue {
  $refs: {
    chatScrollContent: HTMLElement,
    cirurgiaDe: any,
  }

  hTime(s: string) {
    return humanTime(s)
  }

  displayDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'Sem previsão'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'Nova data solicitada'
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    if (item.dataAgendamentoVirtual) return 'Data virtual'
    if (item.dataAgendamento) return this.hTime(item.dataAgendamento)
    if (item.opcaoDataPrevisto1) return this.hTime(item.opcaoDataPrevisto1)
    return 'Sem previsão'
  }

  formatDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'bold__text--grey'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'bold__text--orange'
    if (item.situacaoData.key === 'SemData') return 'bold__text--light-grey'
    if (item.dataAgendamentoVirtual) return 'bold__text--yellow'
    if (item.dataAgendamento) return 'bold__text--grey'
    if (item.opcaoDataPrevisto1) return 'bold__text--red'
    return 'bold__text--grey'
  }

  $user: User;

  readyState: boolean = false
  loadVisualizar: string = ''
  loadVisualizarDrillDown: boolean = false
  loadAutorizada: string = ''
  loadIniciarProcesso: string = ''
  loadAutorizarProcesso: string = ''
  loadRespondePendencia: string = ''
  loadResolverContestacao: string = ''
  loadEmCotacaoSolicitacao: string = ''
  loadConfirmaReservaDeMaterial: string = ''
  loadAvaliaMaterial: string = ''
  loadAtualizaMaterial: string = ''
  loadHistorico: string = ''
  loadComentario: string = ''
  loadVoltarStatus: string = ''
  loadAlterarOpme: string = ''

  loadUpload: boolean = false
  loadMensagem: boolean = false
  modalPendencia: boolean = false
  loadConfirmarReserva: boolean = false
  modalConfirmaReservaDeMaterial: boolean = false
  loadClosePedencia: boolean = false
  loadEncerrarPendencia: boolean = false
  loadConfirmarEncerrarPendencia: boolean = false
  modalConfirmarEncerrarPendencia: boolean = false
  loadCloseConfiramrEncerrarPendencia: boolean = false

  mensagem: string = ''

  inputFiles: any[] = []

  expand: boolean = false
  headers: any[] = [
    { text: '', value: '', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true },
    { text: 'Convênio', value: 'convenioNome', sortable: false, active: true },
    { text: 'Item particular', value: 'temItemParticular', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'Nº da reserva', value: 'numeroAgendamento', sortable: false, active: true },
    { text: 'Status da precificação', value: 'statusPrecificacaoOperadora', sortable: false, active: true },
    { text: 'Situação', value: 'situacao', sortable: false, active: true },
    { text: 'SLA', value: 'statusSla', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
    { text: '', value: '', sortable: false, active: true },
  ]

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  suprimentos: Suprimentos.ISuprimentos = new Suprimentos.Suprimentos()
  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadingPendenciaAdministrativa: string = ''
  loadingSuprimentosAtualizaPrecificacao: string = ''
  areaDoHospital: any = getHospitalAreaName()

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  displayPendencia: any = {
    nomePaciente: '',
    nomeMedico: '',
  }

  reservaDeMaterial: string = ''

  get reservaMaterialId() {
    return this.reservaDeMaterial
  }

  set reservaMaterialId(value: string) {
    this.reservaDeMaterial = value
  }

  get loadingConfirmarReserva() {
    return this.loadConfirmarReserva
  }

  set loadingConfirmarReserva(value: boolean) {
    this.loadConfirmarReserva = value
  }

  get loadingVoltarStatus() {
    return this.loadVoltarStatus
  }

  set loadingVoltarStatus(value: string) {
    this.loadVoltarStatus = value
  }

  get loadingAlterarMateriais() {
    return this.loadAlterarOpme
  }

  set loadingAlterarMateriais(value: string) {
    this.loadAlterarOpme = value
  }

  get loadingComentario() {
    return this.loadComentario
  }

  set loadingComentario(value: string) {
    this.loadComentario = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get loadingAtualizaMaterial() {
    return this.loadAtualizaMaterial
  }

  set loadingAtualizaMaterial(value: string) {
    this.loadAtualizaMaterial = value
  }

  get loadingAvaliaMaterial() {
    return this.loadAvaliaMaterial
  }

  set loadingAvaliaMaterial(value: string) {
    this.loadAvaliaMaterial = value
  }

  get loadingEmCotacaoSolicitacao() {
    return this.loadEmCotacaoSolicitacao
  }

  set loadingEmCotacaoSolicitacao(value: string) {
    this.loadEmCotacaoSolicitacao = value
  }

  get loadingConfirmaReservaDeMaterial() {
    return this.loadConfirmaReservaDeMaterial
  }

  set loadingConfirmaReservaDeMaterial(value: string) {
    this.loadConfirmaReservaDeMaterial = value
  }

  get loadingCloseConfirmarEncerrarPendencia() {
    return this.loadCloseConfiramrEncerrarPendencia
  }

  set loadingCloseConfirmarEncerrarPendencia(value: boolean) {
    this.loadCloseConfiramrEncerrarPendencia = value
  }

  get loadingConfirmarEncerrarPendencia() {
    return this.loadConfirmarEncerrarPendencia
  }

  set loadingConfirmarEncerrarPendencia(value: boolean) {
    this.loadConfirmarEncerrarPendencia = value
  }

  get showModalConfirmarEncerrarPendencia() {
    return this.modalConfirmarEncerrarPendencia
  }

  set showModalConfirmarEncerrarPendencia(value: boolean) {
    this.modalConfirmarEncerrarPendencia = value
  }

  get loadingEncerrarPendencia() {
    return this.loadEncerrarPendencia
  }

  set loadingEncerrarPendencia(value: boolean) {
    this.loadEncerrarPendencia = value
  }

  get loadingResolverContestacao() {
    return this.loadResolverContestacao
  }

  set loadingResolverContestacao(value: string) {
    this.loadResolverContestacao = value
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingRespondePendencia() {
    return this.loadRespondePendencia
  }

  set loadingRespondePendencia(value: string) {
    this.loadRespondePendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return this.displayPendencia
  }

  set getDisplayPendencia(value: any) {
    this.displayPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get showModalConfirmaReservaDeMaterial() {
    return this.modalConfirmaReservaDeMaterial
  }

  set showModalConfirmaReservaDeMaterial(value: boolean) {
    this.modalConfirmaReservaDeMaterial = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get loadingAutorizarProcesso() {
    return this.loadAutorizarProcesso
  }

  set loadingAutorizarProcesso(val: string) {
    this.loadAutorizarProcesso = val
  }

  get loadingAutorizada() {
    return this.loadAutorizada
  }

  set loadingAutorizada(val: string) {
    this.loadAutorizada = val
  }

  get loadingVisualizar() {
    return this.loadVisualizar
  }

  set loadingVisualizar(val: string) {
    this.loadVisualizar = val
  }

  get loadingVisualizarDrillDown() {
    return this.loadVisualizarDrillDown
  }

  set loadingVisualizarDrillDown(val: boolean) {
    this.loadVisualizarDrillDown = val
  }

  get loadingIniciarProcesso() {
    return this.loadIniciarProcesso
  }

  set loadingIniciarProcesso(value: string) {
    this.loadIniciarProcesso = value
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  modDe: boolean = false

  get de() {
    return this.getBackofficeSuprimentosStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getBackofficeSuprimentosStore.setDeFiltro(value)
  }

  get formattedDe() {
    return this.formatDateRange(this.de)
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  formatDateRange(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
    }
  }

  scrollToMensagem() {
    if (this.$refs.chatScrollContent) {
      setTimeout(() => {
        const elem = this.$refs.chatScrollContent

        const option: ScrollToOptions = {
          behavior: 'smooth',
          left: 0,
          top: elem.scrollHeight,
        }
        elem.scrollTo(option)
      }, 0)
    }
  }

  @Watch('showModalPendencia')
  onChangeShowModalPendencia() {
    this.scrollToMensagem()
  }

  async showModalPendenciaAdministrativa(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const { hospitalId } = agendamentoCirurgia
    const solicitacaoId = agendamentoCirurgia.id

    // Set solicitation data from list in BackofficeGlobalStore
    this.getBackofficeGlobalStore.setSolicitationFromList(agendamentoCirurgia as Solicitacao)

    this.loadingPendenciaAdministrativa = solicitacaoId

    let response = await this.suprimentos.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'pendenciaAdministrativa', value: true })
        this.ga('backoffice-suprimentos', 'abrir-modal-pendencia-administrativa')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingPendenciaAdministrativa = ''
  }

  columnSelectionMenu: boolean = false

  hasActiveHeader(value: string) {
    if (value === '') return true
    return this.headers.find(header => header.value === value).active
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-suprimentos-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }

  saveHeaders() {
    (localStorage as any).setItem('backoffice-suprimentos-table-headers', JSON.stringify(this.headers, null, 2))
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getBackofficeSuprimentosStore.clearSolicitacoes()
    this.getBackofficeSuprimentosStore.clearFiltro()
    this.getBackofficeSuprimentosStore.setFilterOn(false)
    this.getBackofficeSuprimentosStore.clearSituacoes()
    this.getBackofficeSuprimentosStore.setSituacoes(SituacaoEnum.AguardandoSuprimentos)
    this.getBackofficeSuprimentosStore.setEtapa('suprimentos')
    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')

    await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
    this.readyState = true
    this.getTableHeaders()
    this.clearLoadingRequest()
  }

  displayReserva(item: any) {
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    return item.numeroAgendamento || 'Sem reserva'
  }

  displayStatusPrecificacao(item: any) {
    if (!item) return 'Sem precificação'
    return item.display
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeSuprimentosStore() {
    return getModule(BackofficeSuprimentosStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get solicitacoes() {
    return this.getBackofficeSuprimentosStore.solicitacoes
  }

  get drawer() {
    return this.getBackofficeSuprimentosStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeSuprimentosStore.setFilterDrawer(value)
  }

  get hospitalFazOrcamentoParticularAvulso() {
    return this.getBackofficeSuprimentosStore.hospitais.some((h: any) => h.hospitalFazOrcamentoParticularAvulso)
  }

  get etapa() {
    return this.getBackofficeSuprimentosStore.situacoes
  }

  set etapa(value: any) {
    this.getBackofficeSuprimentosStore.setSituacoes(value.key)
  }

  get etapas() {
    return [
      { key: 'AguardandoSuprimentos', display: 'Aguardando suprimentos', quantidade: this.getAguardandoSuprimentosTotal },
      { key: 'EmCotacao', display: 'Aguardando cotação', quantidade: this.getEmCotacaoTotal },
      ...this.hospitalFazOrcamentoParticularAvulso ? [{ key: 'OrcamentoParticularAvulsoAguardandoSuprimentos', display: 'Orçamento Avulso Aguardando Suprimentos', quantidade: this.getOrcamentoParticularAvulsoAguardandoSuprimentosTotal }] : [],
      ...this.hospitalFazOrcamentoParticularAvulso ? [{ key: 'OrcamentoParticularAvulsoEmCotacao', display: 'Aguardando cotação de orçamento avulso', quantidade: this.getOrcamentoAvulsoEmCotacaoTotal }] : [],
      { key: 'PendenteReservaDeMaterial', display: 'Pendente reserva de material', quantidade: this.getPendenteReservaDeMaterialTotal },
      { key: 'RetornoDeCotacao', display: 'Retorno de cotação', quantidade: this.getRetornoDeCotacaoTotal },
      { key: 'Pendente', display: 'Pendência médica', quantidade: this.getPendenteTotal },
      { key: 'PendenciaRespondida', display: 'Pendência respondida', quantidade: this.getPendenciaRespondidaTotal },
      { key: 'Incompleta', display: 'Em edição', quantidade: this.getEmEdicaoTotal },
    ]
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get icon() {
    if (this.getAllEtapas) return 'mdi-checkbox-marked'
    if (this.getSomeEtapas) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  get todosOsStatus() {
    return this.getBackofficeSuprimentosStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.getBackofficeSuprimentosStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.getBackofficeSuprimentosStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.getBackofficeSuprimentosStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  selectAllFromHospital() {
    this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
    })
  }

  selectAllFromArea() {
    this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
    })
  }

  selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.getBackofficeSuprimentosStore.clearSituacoes()
    }
    this.etapa = item
  }

  async filterSituacao() {
    if (!this.de) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha o campo de Data de início do período', icon: 'warning', color: '#C62828' })
      return
    }
    this.getBackofficeSuprimentosStore.clearPagePagination()
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  get getAguardandoSuprimentosTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.length > 0
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoSuprimentos).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoSuprimentos)[0].quantidade
    }
    return 0
  }

  get getRetornoDeCotacaoTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.length > 0
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RetornoDeCotacao).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RetornoDeCotacao)[0].quantidade
    }
    return 0
  }

  get getPendenteReservaDeMaterialTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.length > 0
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteReservaDeMaterial).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteReservaDeMaterial)[0].quantidade
    }
    return 0
  }

  get getPendenteTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.length > 0
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente)[0].quantidade
    }
    return 0
  }

  get getPendenciaRespondidaTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.some(c => c.key === SituacaoEnum.PendenciaRespondida)
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida)[0].quantidade
    }
    return 0
  }

  get getEmCotacaoTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.some(c => c.key === SituacaoEnum.EmCotacao)
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.EmCotacao).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.EmCotacao)[0].quantidade
    }
    return 0
  }

  get getOrcamentoParticularAvulsoAguardandoSuprimentosTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.some(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoAguardandoSuprimentos)
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoAguardandoSuprimentos).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoAguardandoSuprimentos)[0].quantidade
    }
    return 0
  }

  get getOrcamentoAvulsoEmCotacaoTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.some(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoEmCotacao)
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoEmCotacao).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.OrcamentoParticularAvulsoEmCotacao)[0].quantidade
    }
    return 0
  }

  get getEmEdicaoTotal() {
    if (this.getBackofficeSuprimentosStore.situacoesCounter.some(c => c.key === SituacaoEnum.Incompleta)
      && this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Incompleta).length > 0) {
      return this.getBackofficeSuprimentosStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Incompleta)[0].quantidade
    }
    return 0
  }

  get getTotal() {
    return this.getBackofficeSuprimentosStore.totalSolicitacoes || 0
  }

  async showModalVisualizarDrillDown(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVisualizarDrillDown = true

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-suprimentos', 'visualizar-aguardando-cotacao')
    this.loadingVisualizarDrillDown = false
  }

  verifyEtapa(item: any) {
    return verifyEtapaSuprimentos(item)
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  getColor(status: string) {
    switch (status) {
      case 'Apto':
        return { color: 'green darken-2', icon: 'thumb_up', tooltip: 'Paciente apto para cirurgia' }
      case 'AptoComAtencao':
        return { color: 'yellow darken-3', icon: 'thumb_up', tooltip: 'Verificar alterações feitas pelo anestesista' }
      case 'NaoApto':
        return { color: 'red darken-3', icon: 'thumb_down', tooltip: 'Paciente não está apto para cirurgia' }
      default:
        return { color: 'orange darken-4', icon: 'schedule', tooltip: 'Avaliação pré-anestésica pendente' }
    }
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.jaPassouPorEsteStatus) {
      classes.push('backoffice-list-table-row__japassouporessestatus')
    }

    if (data.carater.key === 'Urgencia') {
      classes.push('backoffice-list-table-row__urgencia')
    }

    if (data.auditada && this.$user.profile.roles.includes('auditoria') && ['BackofficeAutorizacao', 'BackofficeAgendamento'].includes(this.$route.name!)) {
      classes.push('backoffice-list-table-row__auditada')
    }

    return classes
  }

  async clearAdvancedFilters() {
    this.getBackofficeSuprimentosStore.clearFiltro()
    this.getBackofficeSuprimentosStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    this.clearLoadingRequest()
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  slaColor(statusSla: StatusSlaEnum) {
    switch (statusSla) {
      case StatusSlaEnum.Normal:
        return 'green'

      case StatusSlaEnum.Alerta:
        return 'yellow'

      case StatusSlaEnum.Critico:
        return 'red'

      default:
        return ''
    }
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  /**
   * ========== COMENTÁRIO E LEMBRETE ==========
   */

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  async showComentario(solicitacaoId: string) {
    this.loadingComentario = solicitacaoId
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentario = ''
  }

  lembreteColorDisplay(lembrete: LembreteEnum) {
    return lembreteColor(lembrete)
  }

  /**
   * ========== PAGINAÇÃO ==========
   */

  get getPagina() {
    return this.getBackofficeSuprimentosStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficeSuprimentosStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficeSuprimentosStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficeSuprimentosStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.getBackofficeSuprimentosStore.totalSolicitacoes
  }

  get agendamentoLength() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(pagina: number) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getPagina = pagina
    await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  async mounted() {
    await this.init()

    EventBus.$on('setLembrete', value => this.getBackofficeSuprimentosStore.setLembreteStatus(value))
  }

  /**
   * ============ MODAIS E BOTÕES ==============
   */

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getContestacaoMedicaStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  async showModalVisualizar(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVisualizar = agendamentoCirurgia.id

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-suprimentos', 'visualizar-aguardando-cotacao')
    this.loadingVisualizar = ''
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async showModalConfirmarReservaDeMaterial(agendamentoCirurgia: AgendamentoCirurgia) {
    this.reservaMaterialId = agendamentoCirurgia.id
    this.loadingConfirmaReservaDeMaterial = agendamentoCirurgia.id
    await timeout(600)
    this.showModalConfirmaReservaDeMaterial = true
    this.loadingConfirmaReservaDeMaterial = ''
  }

  async confirmarReservaDeMaterial() {
    this.loadingConfirmarReserva = true
    const request = await this.getBackofficeGlobalStore.backofficeSuprimentosConfirmaReservaDeMateriais(this.reservaMaterialId)

    if (request.success) {
      await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
      this.showModalConfirmaReservaDeMaterial = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao confirmar reserva de materiais', icon: 'warning', color: '#C62828' })
    }
    this.loadingConfirmarReserva = false
  }

  async showModalVoltarStatus(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingVoltarStatus = agendamentoCirurgia.id
    await timeout(500)
    this.getBackofficeGlobalStore.setAgendamentoMedicoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setShowModalVoltarStatus(true)
    this.loadingVoltarStatus = ''
  }

  async showModalAlterarMateriais(agendamentoCirurgia: AgendamentoCirurgia) {
    this.loadingAlterarMateriais = agendamentoCirurgia.id
    const response = await this.getBackofficeGlobalStore.bloquearSolicitacao(agendamentoCirurgia.id)
    if (response.success) {
      const request = await this.getBackofficeGlobalStore.getSolicitacaoAlteradaById(agendamentoCirurgia.id)
      if (request.success) {
        // Tratativa dos procedimentos
        const { procedimento, procedimentosAssociados } = this.getBackofficeGlobalStore.solicitacaoAlterada
        const codigoProcedimentos: any[] = []
        if (procedimentosAssociados.length > 0) procedimentosAssociados.forEach((e: Procedimento) => codigoProcedimentos.push(e.codigo))
        codigoProcedimentos.unshift(procedimento.codigo)

        // Requisições necessárias para preenchimento da modal de edição de opmes
        await Promise.all([
          this.getBackofficeGlobalStore.getGrupoOpmeByMedico(codigoProcedimentos),
          this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId),
          this.getBackofficeGlobalStore.getMedicoOpme(),
          this.getBackofficeGlobalStore.loadFornecedores(),
        ])

        this.getBackofficeGlobalStore.setModal({ name: 'alterarMaterial', value: true })
        this.ga('backoffice-suprimentos', 'alterar-materiais')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao requisitar a solicitação', icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingAlterarMateriais = ''
  }

  async avaliaMaterial(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    this.loadingAvaliaMaterial = solicitacaoId

    let response = await this.autorizacao.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        this.getBackofficeGlobalStore.setModal({ name: 'suprimentos', value: true })
        this.ga('backoffice-suprimentos', 'suprimentos')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingAvaliaMaterial = ''
  }

  async atualizaPrecificacao(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    this.loadingSuprimentosAtualizaPrecificacao = solicitacaoId

    let response = await this.autorizacao.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'atualizarPrecificacao', value: true })
        this.ga('backoffice-suprimentos', 'suprimentos-atualiza-precificacao-operadora')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingSuprimentosAtualizaPrecificacao = ''
  }

  async emCotacaoSolicitacao(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    this.loadingEmCotacaoSolicitacao = solicitacaoId

    let response = await this.suprimentos.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
      if (response.success) {
        await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
        this.getBackofficeGlobalStore.setModal({ name: 'suprimentosCotacao', value: true })
        this.ga('backoffice-suprimentos', 'suprimentos-aguardando-cotacao')
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingEmCotacaoSolicitacao = ''
  }

  async openFlowModal(agendamentoCirurgia: AgendamentoCirurgia | Solicitacao) {
    const solicitacaoId = agendamentoCirurgia.id
    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(solicitacaoId)
    if (response.success) {
      switch (this.getBackofficeGlobalStore.solicitacao.situacao.key) {
        case 'EmCotacao':
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'suprimentosAguardandoCotacao', value: true })
          this.ga('backoffice-suprimentos', 'aguardando-cotacao')
          break

        default:
          EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
          this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
          this.$router.push({ name: 'backoffice-surgery-solicitation-details', params: { solicitacaoId: agendamentoCirurgia.id } })
          break
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
  }

  /** Pendência */
  async showModalRespondePendencia(agendamentoCirurgia: AgendamentoCirurgia) {
    const solicitacaoId = agendamentoCirurgia.id
    this.getBackofficeGlobalStore.setHospitalId(agendamentoCirurgia.hospitalId)
    this.loadingRespondePendencia = solicitacaoId
    let response = await this.autorizacao.bloquearSolicitacao(solicitacaoId)
    if (response.success) {
      response = await this.getPendenciaStore.getPendencias(solicitacaoId)
      if (response.success) {
        this.getDisplayPendencia = {
          nomePaciente: agendamentoCirurgia.pacienteNome,
          nomeMedico: agendamentoCirurgia.medicoNome,
        }
        this.showModalPendencia = true
        this.getBackofficeGlobalStore.setSolicitacaoId(solicitacaoId)
      } else {
        this.getBackofficeSuprimentosStore.deleteSolicitacao(solicitacaoId)
        await this.openFlowModal(agendamentoCirurgia)
        EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'done', color: '#2E7D32' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }
    this.loadingRespondePendencia = ''
    this.ga('backoffice-suprimentos', 'responder-pendencia-aguardando-cotacao')
  }

  async encerrarPendencia() {
    this.loadingEncerrarPendencia = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      const item: AgendamentoSolicitacaoItem = this.getBackofficeSuprimentosStore.solicitacoes.filter(c => c.id === solicitacaoId)[0]
      this.getBackofficeSuprimentosStore.deleteSolicitacao(solicitacaoId)
      await this.openFlowModal(this.getBackofficeGlobalStore.solicitacao)
      await this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
    this.getBackofficeSuprimentosStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAguardandoCotacao(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    let response = await this.getPendenciaStore.uploadDocumento(param)
    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      response = await this.getPendenciaStore.enviarMensagem(pendenciaMensagem)
      if (response.success) {
        this.getBackofficeSuprimentosStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      }
    }

    this.loadingUpload = false
  }

  async confirmarEncerrarPendencia() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingConfirmarEncerrarPendencia = true
    const response = await this.pendenciaSolicitacao.encerrarPendencia(solicitacaoId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência encerrada com sucesso.', icon: 'done', color: '#2E7D32' })
      await this.openFlowModal(this.getBackofficeGlobalStore.solicitacao)
      this.getBackofficeSuprimentosStore.deleteSolicitacao(solicitacaoId)
      this.closeModalPendencia()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao encerrar a pendência.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmarEncerrarPendencia = false
  }

  async confirmarEncerrarPendenciaCloseModal() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalConfirmarEncerrarPendencia = true
    this.loadingClosePendencia = false
  }

  async closeEncerrarPendenciaCloseModal() {
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    this.loadingCloseConfirmarEncerrarPendencia = true
    await this.autorizacao.desbloquearSolicitacao(solicitacaoId)
    this.closeModalPendencia()
  }

  async closeModalPendencia() {
    await timeoutDefault()
    this.showModalPendencia = false
    this.showModalConfirmarEncerrarPendencia = false

    this.loadingCloseConfirmarEncerrarPendencia = false
    this.loadingEncerrarPendencia = false
    this.getDisplayPendencia = {
      nomePaciente: '',
      nomeMedico: '',
    }
    this.getPendenciaStore.clearPendencia()
  }

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  async getAllBackofficeSolicitacoes() {
    this.loadingAllSolicitacoes = true
    const response = await this.getBackofficeSuprimentosStore.loadAgendamentosMedicoSearch()
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    this.loadingAllSolicitacoes = false
  }

  beforeDestroy() {
    this.getBackofficeSuprimentosStore.clearFiltro()
    this.getBackofficeSuprimentosStore.setFilterOn(false)
    this.getBackofficeSuprimentosStore.setTodosOsStatus(false)
    this.getBackofficeSuprimentosStore.setTodosOsStatusDaArea(false)
    this.getBackofficeSuprimentosStore.resetSituacoes()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }

  @Watch('showModalConfirmaReservaDeMaterial')
  onChangeShowModalConfirmaReservaDeMaterial(value) {
    if (!value) {
      this.reservaMaterialId = ''
      this.loadingConfirmarReserva = false
    }
  }
}
